import type { CalendarProvider } from "@plura/shared/types";
import type { SchedulerEmbedProvider } from "../types";
import { calcomEmbedProvider } from "./calcom";
import { calendlyEmbedProvider } from "./calendly";

const PROVIDERS: Partial<Record<CalendarProvider, SchedulerEmbedProvider>> = {
  CALENDLY: calendlyEmbedProvider,
  CALCOM: calcomEmbedProvider,
};

export function getSchedulerEmbedProvider(
  provider: CalendarProvider
): SchedulerEmbedProvider | null {
  return PROVIDERS[provider] ?? null;
}
